/**
 * Shared case-insensitive label lookup over a `redes_sociais` entry's
 * `detalhes` map (`Record<string, {value, label, source, is_deleted?}>`).
 * Used both to source a profile's identifier for "Buscar mais dados"
 * (`redes-sociais-identifier.helper.ts`, task #21219) and to derive an
 * item's dedup identity when merging an incremental result back into the
 * rendered report (`mergeSectionData.helper.ts`, task #21220).
 */

/**
 * First non-blank string/number value among `labels` (case-insensitive,
 * trimmed) found in `detalhes`, or `undefined` if none match. Never throws.
 */
export function lookupFirstLabelValue(
  detalhes: Record<string, { value?: unknown }> | undefined | null,
  labels: readonly string[],
): string | undefined {
  if (!detalhes) {
    return undefined;
  }
  const lowerValues: Record<string, unknown> = {};
  for (const [label, field] of Object.entries(detalhes)) {
    lowerValues[label.trim().toLowerCase()] = field?.value;
  }
  for (const label of labels) {
    const value = lowerValues[label.trim().toLowerCase()];
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
    if (typeof value === "number" && Number.isFinite(value)) {
      return String(value);
    }
  }
  return undefined;
}
